export default function getCookie(key: string): string | undefined {
  return document.cookie
    .split(";")
    .map((c) => c.trim())
    .filter((c) => c.split("=")[0] === key)
    .map((c) => c.split("=")[1])[0];
}
